import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pa-4",
  style: {"height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h5", { class: "ion-text-center mt-1 headline-5" }, "Privacy Policy")
], -1)
const _hoisted_3 = {
  class: "flex",
  style: {"flex-direction":"column"}
}
const _hoisted_4 = { class: "ma-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"48px","height":"48px"} }, null, -1)
const _hoisted_6 = { class: "px-2 pt-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("CONTINUE ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_button = _resolveComponent("close-button")!
  const _component_policy = _resolveComponent("policy")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "pa-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_close_button, { onClick: _ctx.closeMe }, null, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_policy)
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ion_button, {
              onClick: _ctx.closeMe,
              class: "button-blue",
              expand: "full"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}